export const STATUS_COLORS = {
  New: "bg-[#FF1F8E] text-white", Quoted: "bg-[#EBD08A] text-black", Paid: "bg-emerald-100 text-emerald-800",
  "In Production": "bg-sky-100 text-sky-800", Completed: "bg-[#0E0B0D] text-white", Cancelled: "bg-gray-200 text-gray-600",
};
